var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGrid01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1061",
    d: "M0.5,4.1h7.7v7.7H0.5V4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1062",
    d: "M10.7,4.1h24.7v7.7H10.7V4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1063",
    d: "M0.5,14.1h7.7v7.7H0.5V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1064",
    d: "M10.7,14.1h24.7v7.7H10.7V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1065",
    d: "M0.5,24.2h7.7v7.7H0.5V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1066",
    d: "M10.7,24.2h24.7v7.7H10.7V24.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGrid01);
export default __webpack_public_path__ + "static/media/ico-grid-01.cb3cd079635a48e1bdbd7c7eb0033297.svg";
export { ForwardRef as ReactComponent };